import { Reveal } from "./motion";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  { q: "How long does a website take?", a: "Most regular websites are ready in just 4–5 days. Larger, more complex sites typically take 1–2 weeks, depending on scope and how quickly we receive your content." },
  { q: "Do you write the content and provide images?", a: "We can help shape your messaging and source premium stock imagery. Full copywriting and custom photography are available as add-ons if you need them." },
  { q: "Will my website work on mobile?", a: "Always. Every site we build is fully responsive and tested across mobile, tablet and desktop before it goes live." },
  { q: "Do you offer ongoing support?", a: "Yes. Every project includes launch support, and we offer affordable monthly care plans for hosting, updates and peace of mind." },
  { q: "Can you help my site rank on Google?", a: "Absolutely. All packages include SEO fundamentals, and we offer deeper technical and content SEO as an ongoing service." },
];

export default function Faq() {
  return (
    <section id="faq" className="bg-white text-ink py-24 lg:py-36" data-testid="faq-section">
      <div className="max-w-[1000px] mx-auto px-5 sm:px-8">
        <Reveal>
          <div className="text-center mb-14">
            <span className="font-mono text-[11px] uppercase tracking-[0.35em] text-gold">Questions</span>
            <h2 className="font-display font-extrabold tracking-mega leading-[0.98] text-5xl sm:text-6xl mt-4">
              Good to know.
            </h2>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-b border-ink/12">
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="font-display font-bold text-xl sm:text-2xl text-left text-ink hover:text-gold hover:no-underline py-6"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-ink/60 text-base leading-relaxed pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
